import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { T2TemplateBasicComponent } from '../trip2-theme/components/t2-template-basic/t2-template-basic.component';

const routes: Routes = [
  { path: 'pages/administration/billing',
    component: T2TemplateBasicComponent,
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: []
})
export class PagesRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/pages/pages-routing.module.ts